import classNames from 'classnames'
import type {ComponentProps, ReactNode} from 'react'
import S from './styles.module.scss'
import {type UseLazyImgProps, useLazyImgProps} from './useLazyImgProps'
import {withKeyFromProp} from './withKeyFromProp'

interface ImageProps
  extends Omit<ComponentProps<'img'>, 'src'>,
    Omit<UseLazyImgProps, 'src'> {
  // content
  src?: string
  fallback?: ReactNode

  // decoration and interaction
  bordered?: boolean
  shadowed?: boolean
  hoverable?: boolean

  // scaling and positioning
  fluid?: boolean
  contain?: boolean
  //maxWidth?: string | number
  //maxHeight?: string | number
  //fitting?: 'none' | 'contain' | 'cover' | 'scale-down'
  //position?: Justification
  //focus?: CompassDirection
}

export let Image = ({
  bordered,
  contain,
  fallback = null,
  fluid,
  hoverable,
  shadowed,
  ...props
}: ImageProps) => {
  const imgProps = useLazyImgProps(props)
  if (!imgProps) return fallback

  return (
    <img
      {...imgProps}
      className={classNames(
        S.image,
        fluid && S.fluid,
        contain && S.contain,
        bordered && S.bordered,
        shadowed && S.shadowed,
        hoverable && S.hoverable,
        imgProps.className,
      )}
    />
  )
}

Image = withKeyFromProp(Image, 'src')
